module.exports = __webpack_public_path__ + "static/media/28.e9914d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/28.jpg
// module id = 561
// module chunks = 0